<script>
    export let cell_data;
    export let getChecked;
    export let checked;
    let active = false;

</script>

<section>

    <div class="cell_container">

        <div class="cell_wrapper">

            <div class="cell_content">

                <span>{cell_data["c-name"]}</span>
                <span>{cell_data['job-title']}</span>
                <p>{cell_data['occupation']}</p>


            </div>

            <div class="cell_button">

                <div class:active={checked} on:click="{() => active = !active}" on:click={getChecked(cell_data["id"])}></div>

            </div>

        </div>

    </div>

</section>

<style>

    section {
        width: 100%;
        display: flex;
        justify-content: center;
        margin: 2vw 0;
    }

    .cell_container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 96%;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 3px;

    }
    .cell_wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 96%;
        margin: 2vw 0;

    }
    .cell_content {
        display: flex;
        flex-direction: column;
    }
    .cell_content span {
        font-weight: 600;
        font-size: 4vw;
    }
    .cell_content p {
        font-weight: 400;
        font-size: 3vw;
        margin-top: 1vw;
    }
    .cell_button {

    }
    .cell_button div {
        border: 1px solid black;
        content: " ";
        height: 6vw;
        width: 6vw;
    }
    .cell_button .active {
        border: none;
        background-image: url("/assets/svgs/confirm.svg");
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
    }

</style>